{
	"content": {
		"title": "Wybierz materiały wymagające deklaracji",
		"materialListLabel": "Materiał",
		"materialQuantityLabel": "Ilość materiału ({{unit}})",
		"availableQuantityLabel": "Dostępna ilość ({{unit}})",
		"carbonSavingsLabel": "Redukcje emisji CO\u2082 ({{unit}} CO\u2082 eq.)"
	},
	"summary": {
		"title": "Podsumowanie",
		"declarationTypeTitle": "Typ deklaracji",
		"customerProjectTitle": "Projekt klienta",
		"internalProjectOrProductTitle": "Projekt / produkt wewnętrzny",
		"projectReferenceTitle": "Odniesienie do projektu",
		"materialHeaderTitle": "Materiał",
		"quantityHeaderTitle": "Ilość ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Redukcje emisji CO\u2082 do alokacji ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Redukcja emisji CO\u2082 niepodlegająca alokacji ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Ilość jest wymagana",
		"quantityPositive": "Wprowadź dodatnią ilość.",
		"quantityLargerThanAvailable": "Zmniejsz ilość do łącznej dostępnej",
		"savingsRequired": "Redukcje emisji CO\u2082 są wymagane",
		"fetchNotTransferedMaterialsError": "Nie udało się pobrać nieprzeniesionych materiałów"
	},
	"submitTitle": "Dodaj do projektu",
	"backTitle": "Wstecz"
}
